export const colors = {
  by_new_customer_count: '#C8E6C9',
  by_first_ordered_ratio: '#E1BEE7',
  by_order_amount: '#BBDEFB',
  by_ordered_customer_count: '#FFE0B2',
  by_total_customer_count: '#FFCCBC',
  by_followed_customer_count: '#CFD8DC',
  by_followed_ratio: '#B2EBF2',
};
